import AssignmentIcon from "@mui/icons-material/Assignment";
import { Button, useRedirect } from "react-admin";
import { ACCOMMODATION_ORDERS, DormitoryServicePath } from "utils/constants";

const CreateOrderButton = ({ accommodationId }) => {
  const redirect = useRedirect();

  const handleClick = () => {
    const source = encodeURIComponent(JSON.stringify({ accommodationId }));
    redirect(`/${DormitoryServicePath}${ACCOMMODATION_ORDERS}/create?source=${source}`);
  };

  return (
    <Button
      startIcon={<AssignmentIcon />}
      label="Създай заповед"
      onClick={handleClick}
    />
  );
};

export default CreateOrderButton;
